import rehypeSlug from "rehype-slug";

export const plugins = [rehypeSlug];
